import { PropertyMetaData } from './property-meta-data';

export class ModelVersionMetaData extends PropertyMetaData {

    static TYPE = 'ModelVersion';
    protected override _type = ModelVersionMetaData.TYPE;
}
